const CORRECTION_REQUESTS = {
  address: 'address',
  addressProof: 'address_proof',
  curp: 'curp',
  identification: 'identification',
  w8Contract: 'w8_contract'
};

export default CORRECTION_REQUESTS;
